<!-- 支付详情页 -->
<template>
  <div class="container" :style="$store.state.equipment.height">
    <input
      type="file"
      v-show="false"
      @change="uploadBankReceipt"
      ref="fileName1"
    />
    <div class="overview">
      <div class="item">
        <span class="title">订单编号</span>
        <span class="content">{{ orderDetails.orderNo }}</span>
      </div>
      <van-divider :style="{ color: '#1989fa', padding: '0 ', margin: '0' }" />
      <div class="item">
        <span class="title">批次名称</span>
        <span class="content">{{ orderDetails.appraisalBatchName }}</span>
      </div>
      <div class="item">
        <span class="title">考试科目</span>
        <span class="content">{{ orderDetails.subjectName }}</span>
      </div>
      <div class="item">
        <span class="title">考试工种</span>
        <span class="content">{{ orderDetails.occupation }}</span>
      </div>
      <div class="item">
        <span class="title">考试等级</span>
        <span class="content">{{ orderDetails.skillLevel }}</span>
      </div>
      <div class="item"  v-if="orderDetails.examTime != null">
        <span class="title">理论考试时间</span>
        <span class="content">{{ orderDetails.examTime }}</span>
      </div>
      <div class="item" v-if="orderDetails.liveTime != null">
        <span class="title">实操考试时间</span>
        <span class="content">{{ orderDetails.liveTime }}</span>
      </div>
      <div class="item">
        <span class="title">考生名称</span>
        <span class="content">{{ orderDetails.payerName }}</span>
      </div>
      <div class="item">
        <span class="title">性别</span>
        <span class="content">{{ orderDetails.sex }}</span>
      </div>
      <div class="item">
        <span class="title">联系方式</span>
        <span class="content">{{ orderDetails.mobile }}</span>
      </div>
      <div class="item">
        <van-row>
          <van-col  span="7">剩余时间</van-col>
          <van-col ><van-count-down :style="{ color: 'red' }" :time="curTime">
          
          </van-count-down></van-col>
          <van-col span="8">后订单自动关闭</van-col>
        </van-row>
       
      </div>
    </div>
    <div class="button-section">
      <div class="wx-pay">
        <div class="money">
          应付<span class="unit">￥</span>
          <span class="number">{{
            (Math.round(orderDetails.payment * 100) / 100).toFixed(2)
          }}</span>
        </div>
        <button class="wechat-button button" @click="doWexinPay">支付</button>
      </div>
    </div>
  </div>
</template>
 
<script>
import { unipayPay } from "../../utils/wxjssdk";
import fileBox from "@/components/filebox.vue";
import { Dialog } from "vant";
import moment from 'moment';
export default {
  name: "Order",
  components: {
    fileBox,
  },
  data() {
    return {
      orderDetails: {},
      payType: "onlinePay",
      status: 0,
      payFileUrl: "",
      payFileName: "",
      curTime: '',//倒计时
      

    };
  },
  computed: {
   
  },
  created: function () {
    this.fetchOrderDetails();
  },
  methods: {
    fetchOrderDetails: function () {
      const params = {
        orderId: this.$route.query.transOrder,
      };
      this.$http.post("ExamOrder/orderParticulars", params).then((res) => {
        if (res.data.success) {
          console.log(res)
          this.orderDetails = res.data.data.transOrder;
          console.log(this.orderDetails)

          //此处开始赋值时间
          const endTime = moment(this.orderDetails.expiredTime).valueOf()
          const nowTime = moment(new Date()).valueOf()
          console.log('现在的时间',nowTime)
          console.log('结束的时间',endTime)
          this.curTime = endTime - nowTime
          console.log(this.curTime )
          if (this.curTime < 0) {
            
          }
        }
      });
    },

    doWexinPay: function () {
      if(!this.$store.state.equipment.isMobile){
        Dialog.alert({
          confirmButtonColor:'#54B0FB',
          confirmButtonText:'我知道了',
          title: '提示',
          message: 'PC端暂不支持在线支付，现已生成订单，请移步到手机端「我的订单」-「未完成」中，进行支付。'
        }) .then(() => {
                // on confirm
                  this.$router.push({
                    path:"/index",
                    query:this.$router.query
                  })
              })
              .catch(() => {
                // on cancel
              });
        return false
      }
      unipayPay(this.$route.query.transOrder, this.submitPaySuccess)
      
    },
    submitPaySuccess: function () {
      const params = {
        orderId: this.$route.query.transOrder,
        payType: "onlinePay",
      }
      this.$http.post('trans/order/pay', params).then(res => {
          this.$router.replace('/orderpaysuccee')
      })
      // this.$router.push({
      //     path: "/orderpaysuccee",
      //     query: this.$route.query,
      //   });
    },
    payfile() {
      this.status = 1;
      this.$refs.fileName1.click();
    },
    uploadBankReceipt: function (event) {
      var formdata = new FormData();
      formdata.append("file", event.target.files[0]);
      this.$http.post(this.$server.upload, formdata).then((res) => {
        if (res.status == 200) {
          this.payFileUrl = res.data[0].path;
          this.payFileName = res.data[0].fileName;
        }
      });
    },
    bankCardPay: function () {
      if (!this.payFileUrl) {
        this.$message({
          message: "请先上传支付凭证",
          type: "warning",
        });
        return false;
      }
      const params = {
        orderId: this.$route.query.transOrder,
        payType: "payByBankCard",
        payVoucher: this.payFileUrl,
      };
      this.$http.post("/registration/pay/bankCard", params).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          setTimeout(() => {
            this.$router.push("/examore");
          }, 500);
        } else {
          this.$message({
            message: "error",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  background: #eee;
  height: 100vh;
  position: relative;
  color: #666;
  .overview {
    background: #fff;
    .item {
      padding: 16px 0px 16px 30px;
      .title {
        width: 200px;
        display: inline-block;
        text-align: left;
      }
      .content {
        color: #333;
        padding: 14px;
      }
    }
  }
  .org-pay {
    max-height: 357px;
    overflow-y: auto;
    background: #fff;
    margin-top: 18px;
    padding: 24px;
    .title {
      color: #333;
      font-size: 32px;
      padding-top: 12px;
    }
    .radio {
      padding: 12px 0;
    }
    .account {
      font-size: 28px;
      .title {
        font-size: 30px;
        padding-bottom: 12px;
        .remark {
          color: red;
          font-size: 28px;
        }
      }
      .details {
        background: #eee;
        padding: 20px;
        div {
          padding: 6px;
        }
      }
      .files {
        color: #666;
        font-size: 24px;
      }
    }
  }
  .button-section {
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 28px 18px;
    .wx-pay {
      display: flex;
      justify-content: space-between;
      .money {
        .unit {
          color: red;
        }
        .number {
          font-size: 42px;
          color: red;
        }
      }
      .button {
        padding: 12px 48px;
        color: #fff;
        border: none;
        border-radius: 8px;
      }
      .wechat-button {
        background: red;
      }
      .card-button {
        background: #1989fa;
      }
    }
  }
}
</style>